interface OnlineStatusDotProps {
  isOnline: boolean;
  offlineSince?: string | null;
  className?: string;
}

/** Kleiner Status-Punkt: grün = online, grau = offline. Analog zu AddressStatusDot. */
export default function OnlineStatusDot({
  isOnline,
  offlineSince,
  className = '',
}: OnlineStatusDotProps) {
  const color = isOnline ? 'bg-green-500' : 'bg-gray-400';
  const label = isOnline
    ? 'Online'
    : offlineSince
      ? `Offline seit ${new Date(offlineSince).toLocaleDateString('de-DE')}`
      : 'Offline';

  return (
    <span
      className={`shrink-0 w-2 h-2 rounded-full ${color} ${className}`}
      title={label}
      aria-label={label}
      role="img"
    />
  );
}
